exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-minimum-fee .loans-detail-minimum-fee{padding-top:17px;align-items:center;display:-moz-flex;display:-ms-flexbox;display:flex}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:start;align-items:start}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile .btn-app.btn-primary{width:210px;height:38px;line-height:41px;margin-bottom:20px}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile .minimum-fee{margin-left:0}loans-detail-minimum-fee .loans-detail-minimum-fee .btn-app.btn-primary{width:252px;height:48px;line-height:52px}loans-detail-minimum-fee .loans-detail-minimum-fee .minimum-fee{margin-left:50px;margin-bottom:0}loans-detail-minimum-fee .loans-detail-minimum-fee .minimum-fee span{font-weight:700;font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailMinimumFee/loansDetailMinimumFee.scss
// module id = 1852
// module chunks = 0